/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_App_Read_LaterInputs */

const en_why_listening_app_read_later = /** @type {(inputs: Why_Listening_App_Read_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read-later app`)
};

const es_why_listening_app_read_later = /** @type {(inputs: Why_Listening_App_Read_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App para leer más tarde`)
};

/**
* | output |
* | --- |
* | "Read-later app" |
*
* @param {Why_Listening_App_Read_LaterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_app_read_later = /** @type {((inputs?: Why_Listening_App_Read_LaterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_App_Read_LaterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_app_read_later(inputs)
	return en_why_listening_app_read_later(inputs)
});